import React from 'react';
import StatusMetersPage from './StatusMetersPage';

export default function PendingToVerify() {
  return (
    <StatusMetersPage
      status="Pending"
      title="Pending to Verify"
      showViewMore
      installationReview
    />
  );
}
